import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { LocalService, NcWeatherOptions } from './local.service';

const fadeInOut = trigger('fadeInOut', [
  transition(':enter', [
    style({ opacity: 0 }),
    animate(400, style({ opacity: 1 }))
  ]),
  transition(':leave', [
    animate(400, style({ opacity: 0 }))
  ])
]);

const slideInOut = trigger('slideInOut', [
  transition(':enter', [
    style({ transform: 'translateY(-100%)' }),
    animate(300, style({ transform: 'translateY(0)' }))
  ]),
  transition(':leave', [
    animate(300, style({ transform: 'translateY(-100%)' }))
  ])
]);

@Component({
  selector: 'nc-weather',
  templateUrl: './weather.component.html',
  styleUrls: ['./weather.component.less'],
  animations: [fadeInOut, slideInOut]
})
export class WeatherComponent implements OnInit, OnDestroy {
  @Input() ncToken: string = '';
  @Input() ncLng: string | number = '';
  @Input() ncLat: string | number = '';
  @Input() ncInterval: number = 30;//刷新频率：分钟
  @Input() ncPosition: 'rightBottom' | 'leftBottom' | 'rightTop' | 'leftTop' = 'rightBottom';//详情面板相对于bar的位置
  @Input() ncAnimation: 'default' | 'fade' | 'slide' = 'default';//fade：淡入淡出 slide：滑入滑出 default：无动画
  //位置信息
  @Input() set ncShowLocation(value: boolean | string) {
    this.showLocationMode = value !== null && value !== undefined && value !== false && value !== 'false';
  }
  //24小时预报
  @Input() set ncShowHourly(value: boolean | string) {
    this.showHourlyMode = value !== null && value !== undefined && value !== false && value !== 'false';
  }
  //5天预报
  @Input() set ncShowDaily(value: boolean | string) {
    this.showDailyMode = value !== null && value !== undefined && value !== false && value !== 'false';
  }
  //生活指数
  @Input() set ncShowLife(value: boolean | string) {
    this.showLifeMode = value !== null && value !== undefined && value !== false && value !== 'false';
  }

  showLocationMode: boolean = false;
  showHourlyMode: boolean = false;
  showDailyMode: boolean = false;
  showLifeMode: boolean = false;

  detailShow: boolean = false;
  weatherData: any = {};
  reloadInterval: any;

  constructor(private ls: LocalService) {
  }

  async ngOnInit(): Promise<void> {

    if (this.ncToken == '') {
      console.error('ncToken为空');
      return;
    }

    this.getWeatherData();
  }

  ngOnDestroy(): void {
    clearInterval(this.reloadInterval);
  }

  async getWeatherData() {
    if (this.reloadInterval) {
      clearInterval(this.reloadInterval);
      this.reloadInterval = null;
    }
    await this.updateWeatherData();
    this.reloadInterval = setInterval(async () => {
      await this.updateWeatherData();
    }, this.ncInterval * 60 * 1000);
  }

  async updateWeatherData() {
    const options: NcWeatherOptions = {
      lng: this.ncLng,
      lat: this.ncLat
    }
    let data = await this.ls.getWeather(this.ncToken, options);
    //对温度取整、时间处理
    data.realtime.temperature.value = Math.round(data.realtime.temperature.value);
    data.realtime.temperature.min = Math.round(data.realtime.temperature.min);
    data.realtime.temperature.max = Math.round(data.realtime.temperature.max);
    data.serverTime.value = this.ls.formatDate('HH:mm', data.serverTime.value);
    for (let h of data.hourly.value) {
      h.time = this.ls.formatDate('HH时', h.time);
      h.temperature.value = Math.round(h.temperature.value);
    }
    for (let d of data.daily.value) {
      d.date = this.ls.formatDate('MM-dd', d.date);
      d.temperature.min = Math.round(d.temperature.min);
      d.temperature.max = Math.round(d.temperature.max);
    }
    this.weatherData = data;
  }
}
